export type Environment = "prod" | "int" | "stage";

export const AllEnvironments: Environment[] = ["prod", "int", "stage"];
